import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { Component, Input, Inject, OnChanges, OnInit } from '@angular/core';
import { LookupState } from '@ngxs-store/lookup-store/lookup.state';
import { LookupModel, TicketsModel } from '@core/services/api.service';
import { Observable } from 'rxjs';
import { LoadTicketTypesAction } from '@ngxs-store/lookup-store/lookup.actions';
import { CreateTicketAction } from '@ngxs-store/log-tickets-store/log-tickets.actions';

@Component({
  selector: 'app-log-ticket-dialog',
  templateUrl: './log-ticket-dialog.html',
})
export class LogTicketDialogComponent  implements OnInit, OnChanges {
    @Select(LookupState.getTicketTypes) ticketTypes$: Observable<LookupModel[]>;
    @Input() isLoading: boolean;
    @Input() isMobileMode: boolean;
    @Input() ticketTypes: LookupModel[];

    description : string;
    comments: string;
    longDescription: string;
    file: string;
    ticketTypeId: number = 31;
    attachment: File;
    ticketTypesList: LookupModel[];

    viewTicket: TicketsModel;
    readOnly: boolean = false;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any,
    private store: Store) {
        this.viewTicket = data.ticket || {};
        this.readOnly = data.readonly;
        this.ticketTypeId = this.viewTicket.id || 31;
        this.description = this.viewTicket.description || '';
        this.longDescription = this.viewTicket.longDescription || '';
        this.comments = data.comments;
    }

    ngOnInit() {
        this.store.dispatch(new LoadTicketTypesAction());
        this.ticketTypes$.subscribe(types => {
          this.ticketTypesList = types;
          if (this.ticketTypesList && this.ticketTypesList.length > 0 && !this.ticketTypeId) {
            this.ticketTypeId = this.ticketTypesList[0].id;
          }
        });
      }

    ngOnChanges() {
        let ticketTypeSelected = this.ticketTypesList.find(x => x.id === this.ticketTypeId);
        if (ticketTypeSelected) {
          this.ticketTypeId = ticketTypeSelected.id;
        }
    }

    onFileSelected(event: any){
        const file: File = event.target.files[0];
        if (file) {
            if (file) {
                this.attachment = file;
            }
        }
    }

    onSubmit(){
        const formData = new FormData();
        formData.append('ticketType', this.ticketTypeId.toString());
        formData.append('description', this.description);
        formData.append('longDesc', this.longDescription);
        if (this.attachment) {
            formData.append('attachment', this.attachment, this.attachment.name);
        }

        this.store.dispatch(new CreateTicketAction(formData));
        this.dialogRef.closeAll();
    }

    onCancelClick() {
        this.dialogRef.closeAll() ;
    }
}
